import styles from './Template.module.scss';
import ProductGalleryInfo from './productGalleryInfo';
import { ProductsCategory, productsKeyConstants } from '../../../../config';
import { getProducts } from '../../../../commons/utils/productsHelper';
import { useAppDispatch, useAppSelector } from '../../../../src/app/hooks';
import {
  addItemToCart,
  getCartItems,
} from '../../../../src/features/cart/cartState';
import Faq from '../../faq/faq';
import YotpoReviews from '../../global/YotpoReviews/YotpoReviews';
import Ingredients from '../../ingredients/Ingredients';
import CustomerStories from '../../homepage/customerStories/customerStories';
import Body from './body/Body';
import Benefits from './benefits/Benefits';
import StoryTimeline from '../../story-timeline/storyTimeline';
import StickyNavBar from './StickyNavBar/StickyNavBar';
import ProductCarousel from '../../global/ProductCarousel/ProductCarousel';
import {
  GA4MiniCart,
  GASelectedItem,
} from '../../../../commons/helpers/Analytics/googleAnalytics';

import { FBAddToCart } from '../../../../commons/helpers/Analytics/fbPixel';
import { vwoHelper } from '../../../../commons/helpers/Analytics/vwo/vwoHelper';
import { config } from '../../../../config';

export default function ProductTemplate({ productType, userId = null }) {
  const products = getProducts();
  const dispatch = useAppDispatch();
  const cartItems = useAppSelector(getCartItems);

  const handleSubmit = (productKey) => {
    const productIds = Object.keys(cartItems);
    const selectedProduct = products[productKey];
    var flag = false;

    if (selectedProduct.category == 'ZFA') {
      flag = true;
    }
    try {
      if (productKey.includes('REL')) {
        const options = {
          eventProperties: {
            'product-id': selectedProduct.productId,
            'product-name': selectedProduct.productName,
            'sku': selectedProduct.sku,
            'price': selectedProduct.recurringPrice,
            'quantity': '1',
          },
        };
        vwoHelper.vwoClientInstance.track(
          config.vwo.campaignKey,
          userId,
          'add-to-cart',
          options
        );
      }
    } catch (err) {
      console.log('VWO Error:', err);
    }

    const isSubscription = selectedProduct.isSubscription;
    FBAddToCart(selectedProduct, isSubscription, 0, flag);
    GASelectedItem(0, selectedProduct, isSubscription);
    GA4MiniCart(0, selectedProduct, 0, isSubscription);
    if (
      productIds.includes(selectedProduct?.quoteParams?.productId) &&
      cartItems[selectedProduct?.quoteParams?.productId].key == productKey
    ) {
      const payload = {
        productId: selectedProduct?.quoteParams?.productId,
        data: {
          key: productKey,
          quantity:
            cartItems[selectedProduct?.quoteParams?.productId].quantity + 1,
          isSubscription: selectedProduct?.isSubscription,
          category: selectedProduct?.category,
        },
      };
      dispatch(addItemToCart(payload));
    } else {
      const payload = {
        productId: selectedProduct?.quoteParams?.productId,
        data: {
          key: productKey,
          quantity: selectedProduct?.quoteParams?.quantity,
          isSubscription: selectedProduct?.isSubscription,
          category: selectedProduct?.category,
        },
      };
      dispatch(addItemToCart(payload));
    }
  };

  return (
    <>
      <StickyNavBar productType={productType} />
      <ProductGalleryInfo
        productType={productType}
        handleSubmit={handleSubmit}
        id="buy"
      />
      <div style={{ width: '100%' }}>
        {<Benefits productType={productType} />}
      </div>
      <StoryTimeline productType={productType} />
      <Body id="howitworks" productType={productType} />
      <Ingredients productType={productType} id="ingredients" />
      <CustomerStories id="testimonials" productType={productType} />
      {/* <HowBodyWorks id="howitworks" />
      <FullbleedImgSection id="ingredients" />
      <ProductGalleryInfo
        productType={productType}
        handleSubmit={handleSubmit}
        id="buy"
      /> */}
      {/* <div style={{ width: '100%' }}>
        {<Benefits productType={productType} />}
      </div> */}
      {/* <TestimonialCarousel id="testimonials" /> */}
      {(ProductsCategory.RELIEF_FACTOR == productType ||
        ProductsCategory.Z_FACTOR == productType) && (
        <div className={styles.yotpoReviewExtender} id="review">
          <div className={styles.yotpoReviewContainer}>
            <YotpoReviews
              product={
                ProductsCategory.RELIEF_FACTOR == productType
                  ? productsKeyConstants.RF_RELIEF_FACTOR_QS
                  : productsKeyConstants.RF_Z_FACTOR
              }
            />
          </div>
        </div>
      )}
      <Faq productType={productType} id="faq" />
      <ProductCarousel />
    </>
  );
}
